import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Link from '@src/components/link';
import styles from './index.less';

/**
 * 导航组件
 * @param {Object} props
 * @param {Object} props.store - ListStore 实例
 */
const Nav = observer(({ store }) => {
  const navItems = [
    {
      id: 11867,
      name: '明教觉醒',
      groupClass: 'xfe-group-28',
      defaultClass: 'xfe-layer-57',
      activeClass: 'xfe-layer-58'
    },
    {
      id: 11866,
      name: '战域云顶',
      groupClass: 'xfe-group-29',
      defaultClass: 'xfe-layer-59',
      activeClass: 'xfe-layer-60'
    },
    {
      id: 11868,
      name: '跨服拍卖',
      groupClass: 'xfe-group-30',
      defaultClass: 'xfe-layer-61',
      activeClass: 'xfe-layer-62'
    },
    {
      id: 11869,
      name: '开年新服',
      groupClass: 'xfe-group-31',
      defaultClass: 'xfe-layer-63',
      activeClass: 'xfe-layer-64'
    },
    {
      id: 11870,
      name: '你提我改',
      groupClass: 'xfe-group-32',
      defaultClass: 'xfe-layer-65',
      activeClass: 'xfe-layer-66'
    },
    {
      id: 11871,
      name: '百万金币',
      groupClass: 'xfe-group-33',
      defaultClass: 'xfe-layer-67',
      activeClass: 'xfe-layer-68'
    }
  ];

  return (
    <div className="xfe-group-27" data-name="导航">
      <div className="xfe-layer-55" data-name="背景" />
      <Link className="xfe-layer-56" data-name="返回首页" href="index.html" />
      {navItems.map(item => (
        <Link
          key={item.id}
          className={classNames(item.groupClass, styles.navBtn, `nav-article-${item.id}`, { [styles.active]: store.articleId === item.id })}
          data-name={item.name}
          onClick={() => store.navToList(item.id)}
        >
          <div className={item.defaultClass} />
          <div className={item.activeClass} />
        </Link>
      ))}
    </div>
  );
});

export default Nav;
